import React from 'react';
import { Download, UserPlus, BookOpenCheck, Rocket } from 'lucide-react';

const steps = [
  {
    num: '01',
    icon: Download,
    title: 'Download Aplikasi',
    desc: 'Unduh Tradiora dari App Store atau Google Play secara gratis.',
  },
  {
    num: '02',
    icon: UserPlus,
    title: 'Daftar Akun Gratis',
    desc: 'Buat akun dalam 1 menit. Tanpa dokumen yang rumit.',
  },
  {
    num: '03',
    icon: BookOpenCheck,
    title: 'Ikuti Akademi & Mentoring',
    desc: 'Belajar dari mentor profesional dan akses materi terstruktur.',
  },
  {
    num: '04',
    icon: Rocket,
    title: 'Mulai Trading dengan AI',
    desc: 'Trading saham & crypto dengan bantuan analisis AI real-time.',
  },
];

function HowItWorks() {
  return (
    <section className="how-it-works" style={{
      padding: '100px 0', position: 'relative', overflow: 'hidden',
      background: 'linear-gradient(135deg, #0b1120 0%, #0f1a3a 50%, #1a0f2e 100%)',
    }}>
      {/* Animated grid background */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `radial-gradient(rgba(12,143,134,0.05) 1px, transparent 1px)`,
        backgroundSize: '50px 50px',
        pointerEvents: 'none', opacity: 0.6,
      }} />
      <div style={{
        position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 600, height: 600, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(12,143,134,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row">
          <div className="col-md-12">
            <div className="block-text center" style={{ marginBottom: 64 }}>
              <h3 className="heading" style={{ color: '#fff' }}>Cara Memulai</h3>
              <p className="fs-20" style={{ color: 'rgba(255,255,255,0.55)', maxWidth: 500, margin: '12px auto 0' }}>
                Hanya 4 langkah mudah untuk memulai perjalanan trading Anda bersama Tradiora.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12">
            <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', flexWrap: 'wrap', gap: 20 }}>
              {/* Connecting line */}
              <div style={{
                position: 'absolute', top: 52, left: '8%', right: '8%', height: 2,
                background: 'linear-gradient(90deg, transparent 0%, rgba(12,143,134,0.5) 20%, rgba(12,143,134,0.5) 80%, transparent 100%)',
                zIndex: 0,
              }} className="how-line" />

              {steps.map((step, index) => {
                const Icon = step.icon;
                return (
                  <div
                    key={step.num}
                    className="how-step"
                    data-aos="fade-up"
                    data-aos-delay={index * 150}
                    style={{
                      flex: '1 1 180px', textAlign: 'center',
                      position: 'relative', zIndex: 1, padding: '0 12px',
                    }}
                  >
                    <div style={{
                      width: 72, height: 72, borderRadius: '50%',
                      background: 'linear-gradient(135deg, #0C8F86, #087a72)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 20px',
                      boxShadow: '0 10px 40px rgba(12,143,134,0.35)',
                      position: 'relative',
                      animation: 'pulse 2.5s infinite',
                    }}>
                      <Icon size={30} color="#fff" />
                    </div>
                    <div style={{
                      width: 30, height: 30, borderRadius: '50%',
                      background: '#0C8F86', color: '#fff',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 14px', fontSize: 12, fontWeight: 700,
                      border: '3px solid #0b1120',
                    }}>
                      {step.num}
                    </div>
                    <h5 style={{ color: '#fff', fontSize: 17, fontWeight: 700, marginBottom: 10 }}>
                      {step.title}
                    </h5>
                    <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, lineHeight: 1.7, maxWidth: 200, margin: '0 auto' }}>
                      {step.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
